export interface EventSeat {
  id: number
  name: string | null
  email: string | null
  answers: { prompt: string; value: string }[]
}

export function EventSeatAnswers({ seats }: { seats: EventSeat[] }) {
  return seats.map((seat, index) =>
    seat.answers.map((answer) => (
      <p key={`${seat.id}-${answer.prompt}`} className="mt-1 text-caption text-muted-foreground">
        <span className="font-medium text-foreground">
          {seat.name || `Seat ${index + 1}`} · {answer.prompt}
        </span>{' '}
        · {answer.value}
      </p>
    )),
  )
}
